module.exports = __webpack_public_path__ + "static/img/iphone_msp2.bed1865.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_msp2.png
// module id = pnk+
// module chunks = 0